export var MessageCategory;

(function (MessageCategory) {
  MessageCategory["TYPE_WEBSOCKET_CONNECTION"] = "WEBSOCKET-CONNECTION";
  MessageCategory["TYPE_LOGIN"] = "LOGIN";
  MessageCategory["TYPE_LOGOUT"] = "LOGOUT";
  MessageCategory["TYPE_TEXT_MESSAGE"] = "TEXT-MESSAGE";
  MessageCategory["TYPE_ROOM"] = "ROOM";
  MessageCategory["TYPE_CONNECTION"] = "CONNECTION";
  MessageCategory["TYPE_OFFER"] = "OFFER";
  MessageCategory["TYPE_ANSWER"] = "ANSWER";
  MessageCategory["TYPE_NEW_USER"] = "NEW USER";
  MessageCategory["TYPE_SIGNAL"] = "PEER-SIGNAL";
  MessageCategory["TYPE_JOIN_ROOM"] = "JOIN-ROOM";
  MessageCategory["TYPE_JOIN_ROOM_RESPONSE"] = "JOIN-ROOM-RESPONSE";
  MessageCategory["TYPE_LEAVE_ROOM"] = "LEAVE-ROOM";
  MessageCategory["TYPE_LEAVE_ROOM_RESPONSE"] = "LEAVE-ROOM-RESPONSE";
  MessageCategory["TYPE_OFFER_TO_BRIDGE"] = "OFFER-TO-BRIDGE";
  MessageCategory["TYPE_SIGNAL_TO_BRIDGE"] = "PEER-SIGNAL-TO-BRIDGE";
  MessageCategory["TYPE_FORCED_LOGGED_OUT"] = "FORCED-LOGGED-OUT";
})(MessageCategory || (MessageCategory = {}));

export var JoinRoomAction;

(function (JoinRoomAction) {
  JoinRoomAction["Wait"] = "WAIT";
  JoinRoomAction["InitiateCall"] = "INITIATE_CALL";
  JoinRoomAction["None"] = "NONE";
})(JoinRoomAction || (JoinRoomAction = {}));

export var ServerResponseStatus;

(function (ServerResponseStatus) {
  ServerResponseStatus["Failed"] = "FAILED";
  ServerResponseStatus["Success"] = "SUCCESS";
})(ServerResponseStatus || (ServerResponseStatus = {}));

export var SignalServerErrorCodes;

(function (SignalServerErrorCodes) {
  SignalServerErrorCodes["INVALID_SECURITY_CODE"] = "10001";
  SignalServerErrorCodes["ERROR_WITH_API_CALL"] = "10002";
  SignalServerErrorCodes["JOIN_ROOM_USER_COUNT_THRESHOLD_REACHED"] = "10003";
})(SignalServerErrorCodes || (SignalServerErrorCodes = {}));